// <!-- Longchamp Policy -->
import { fetchCart } from "./theme.js?v=2";

const validateLongchamp = (cart, redirect = false) => {
  const selectedVendor = "Longchamp";
  const cartItems = cart.items;
  const longchampItems = cartItems.filter(
    (item) => item.vendor === selectedVendor
  );

  for (const item of longchampItems) {
    if (item.quantity > 3) {
      if (redirect) {
        window.location.href = "/cart";
        return;
      }
      const lineItems = document.querySelectorAll(
        `.line-item[data-variant-id="${item.id}"]>.line-item-info`
      );
      for (const lineItem of lineItems) {
        const div = document.createElement("div");
        div.className = "text-error";
        div.textContent =
          "You can only purchase three items per style per transaction. Please modify your order.";
        lineItem.append(div);
      }
      const cartForm = document.querySelector("#cart-page-main");
      if (cartForm) {
        const checkoutButton = cartForm["checkout"];
        checkoutButton.disabled = true;
        checkoutButton.classList.add("button--subdued");
        checkoutButton.classList.add("button--outline");
      }
    }
  }

  const totalQuantity = longchampItems.reduce(
    (total, item) => total + item.quantity,
    0
  );
  if (totalQuantity > 10) {
    if (redirect) {
      window.location.href = "/cart";
      return;
    }
    const lineItems = document.querySelectorAll(
      `.line-item[data-vendor="${selectedVendor}"]>.line-item-info`
    );
    for (const lineItem of lineItems) {
      const div = document.createElement("div");
      div.className = "text-error";
      div.textContent =
        "Your purchase exceeds the limit of 10 Longchamp items. Please modify your order.";
      lineItem.append(div);
    }
    const cartForm = document.querySelector("#cart-page-main");
    if (cartForm) {
      const checkoutButton = cartForm["checkout"];
      checkoutButton.disabled = true;
      checkoutButton.classList.add("button--subdued");
      checkoutButton.classList.add("button--outline");
    }
  }
};
document.addEventListener("DOMContentLoaded", async function (event) {
   fetchCart
      .then((data) => {
        validateLongchamp(data);
      })
      .catch((error) => console.error("There was an error!", error));
});

document.addEventListener("cart:change", function (event) {
  setTimeout(()=>{
    validateLongchamp(event.detail.cart);
  },100)
});
